function trimTrailingSlash(url: string) {
  return url.replace(/\/+$/, '');
}

function normalizeEnvUrl(rawUrl: string | undefined) {
  const trimmedUrl = rawUrl?.trim();
  if (!trimmedUrl) {
    return '';
  }

  return trimTrailingSlash(trimmedUrl);
}

export function getBrowserOriginUrl() {
  if (typeof window === 'undefined') {
    return '';
  }

  return trimTrailingSlash(window.location.origin);
}

export function getAppSelectorUrl() {
  return normalizeEnvUrl(import.meta.env.VITE_APP_SELECTOR_URL) || getBrowserOriginUrl();
}

export function getLoansAppUrl() {
  return normalizeEnvUrl(import.meta.env.VITE_LOANS_URL) || getBrowserOriginUrl();
}

export function getExternalAppUrl(rawUrl: string | undefined) {
  return normalizeEnvUrl(rawUrl) || getAppSelectorUrl() || getBrowserOriginUrl();
}
